/* eslint-disable react/jsx-props-no-spreading */

import React from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";

const Input = ({
  className,
  error,
  label,
  name,
  placeholder,
  register,
  required,
  type,
  _css,
  ...rest
}) => {
  const title = name.replace(/([a-z])([A-Z])/g, `$1 $2`);
  let errorMessage;
  if (error?.type === `required`) {
    errorMessage = (
      <p
        className="b2"
        css={css`
          color: var(--color-raspberry-dark);
          margin-bottom: 0.75rem;
        `}
      >
        <span
          css={css`
            text-transform: capitalize;
          `}
        >
          {title}
        </span>
        {` `}
        is required
      </p>
    );
  }

  if (label) {
    return (
      <label htmlFor={name}>
        <span>
          {label}
          {required && `*`}
        </span>
        <input
          type={type}
          placeholder={placeholder}
          {...register(name, { required })}
          {...rest}
          className={className}
          css={css`
            ${_css} ${error?.type && `border: 1px solid red;`}
          `}
        />
        {errorMessage && errorMessage}
      </label>
    );
  }

  return (
    <>
      <input
        type={type}
        placeholder={placeholder}
        {...register(name, { required })}
        {...rest}
        className={className}
        css={css`
          ${_css} ${error?.type && `border: 1px solid red;`}
        `}
      />
      {errorMessage && errorMessage}
    </>
  );
};

export default Input;

Input.propTypes = {
  className: PropTypes.string,
  error: PropTypes.shape({
    type: PropTypes.string
  }),
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  register: PropTypes.func,
  required: PropTypes.bool,
  type: PropTypes.string,
  _css: PropTypes.shape({})
};

Input.defaultProps = {
  className: ``,
  error: {
    type: ``
  },
  label: ``,
  placeholder: ``,
  register: () => {},
  required: false,
  type: `text`,
  _css: {}
};
